/** Human labels for audit actions (app/services/audit.py callers). */
export const AUDIT_ACTION_LABEL: Record<string, string> = {
  login: 'Signed in',
  login_failed: 'Failed sign-in',
  login_blocked: 'Sign-in blocked',
  password_reset: 'Password reset',
  mfa_enabled: 'Two-factor turned on',
  mfa_disabled: 'Two-factor turned off',
  user_invited: 'User invited',
  invite_accepted: 'Invitation accepted',
  invite_cancelled: 'Invitation cancelled',
  user_updated: 'User changed',
  user_removed: 'User removed',
  role_assigned: 'Role given',
  role_removed: 'Role removed',
  security_policy_updated: 'Sign-in policy changed',
  sso_configured: 'Single sign-on set up',
  sso_updated: 'Single sign-on changed',
  sso_removed: 'Single sign-on removed',
  api_token_created: 'API token created',
  api_token_revoked: 'API token revoked',
  share_link_created: 'Public link created',
  share_link_revoked: 'Public link revoked',
  data_exported: 'Data exported',
  deletion_requested: 'Workspace deletion scheduled',
  deletion_cancelled: 'Workspace deletion cancelled',
  plan_changed: 'Plan changed',
  gate_submitted: 'Gate submitted',
  gate_approved: 'Gate approved',
  gate_sent_back: 'Gate sent back',
  subscription_cancelled: 'Subscription ended',
  intake_approved: 'Request approved',
  intake_rejected: 'Request rejected',
  intake_deferred: 'Request deferred',
  intake_converted: 'Request turned into a project',
  product_created: 'Product created',
  product_updated: 'Product changed',
  product_deleted: 'Product deleted',
  product_linked: 'Work linked to product',
  product_unlinked: 'Work unlinked from product',
  product_metric_added: 'Product metric added',
  product_metric_deleted: 'Product metric deleted',
  idea_submitted: 'Idea submitted',
  idea_status_changed: 'Idea status changed',
  idea_sent_to_intake: 'Idea sent to intake',
  idea_deleted: 'Idea deleted',
  capacity_hours_changed: 'Weekly hours changed',
  budget_category_added: 'Budget category added',
  budget_category_changed: 'Budget category changed',
  budget_category_deleted: 'Budget category deleted',
  raid_imported_from_notes: 'RAID items added from meeting notes',
  workspace_deleted: 'Workspace deleted',
}

export const AUDIT_WARN_ACTIONS = new Set(['login_failed', 'login_blocked', 'mfa_disabled', 'user_removed', 'deletion_requested',
  'sso_removed', 'subscription_cancelled', 'product_deleted', 'budget_category_deleted', 'product_metric_deleted'])

export function actionLabel(action: string): string {
  return AUDIT_ACTION_LABEL[action] ?? action.replace(/_/g, ' ').replace(/^\w/, (c) => c.toUpperCase())
}
